<template>
  <Dialog
    v-model:visible="dialogVisible"
    modal
    :draggable="false"
    :style="{ width: '24rem' }"
    :pt="{
      root: { class: 'border-0! bg-transparent!' },
      mask: { class: 'backdrop-blur-xs' },
    }"
    @update:visible="$emit('update:visible', $event)"
  >
    <template #container="{ closeCallback }">
      <div
        class="flex flex-col items-center px-8 py-10 gap-6 rounded-2xl bg-linear-to-br from-amber-50 via-white to-amber-50 border border-amber-200 shadow-xl"
      >
        <!-- Lock Icon -->
        <div
          class="w-16 h-16 rounded-full bg-linear-to-br from-amber-400 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/30"
        >
          <span class="pi pi-lock text-2xl text-white"></span>
        </div>

        <!-- Content -->
        <div class="text-center">
          <h3 class="text-xl font-semibold text-slate-900 mb-2">
            {{ $t('messages.quickValuation.regionLocked.title') }}
          </h3>
          <p class="text-sm text-slate-600 mb-4">
            {{ $t('messages.quickValuation.regionLocked.subtitle') }}
          </p>
          <p class="text-sm text-slate-500">
            {{ $t('messages.quickValuation.regionLocked.description', { region: regionName }) }}
          </p>
        </div>

        <!-- CTA Button -->
        <div class="flex flex-col gap-3 w-full">
          <Button
            v-if="showCta"
            :label="$t('messages.quickValuation.regionLocked.cta')"
            class="w-full bg-linear-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 border-0!"
            @click="onUpgradeClick(closeCallback)"
          />
          <Button
            :label="$t('messages.close')"
            text
            severity="secondary"
            class="w-full"
            @click="closeCallback"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  regionName: {
    type: String,
    default: '',
  },
  showCta: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['update:visible'])

const dialogVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value),
})

const onUpgradeClick = (closeCallback) => {
  // For now, just close the dialog - CTA functionality can be added later
  closeCallback()


}
</script>
